module.exports = __webpack_public_path__ + "static/media/07.ff00e2b0.webp";